import { useEffect, useState } from 'react';
import Modal from './Modal';
import {
  ascoltaInstallazione, homeProponibile, piattaforma, dentroUnAltraApp, browserIphone,
  puoInstallareSubito, installaOra, statoHome, segnaHome,
} from '../installazione';

// "Metti Jammo sulla Home", in tre pezzi:
// - SchedaHome: la proposta nella pagina della serata, a chi partecipa o
//   organizza. Una volta: "Non ora" o "Fatto" la tolgono per sempre.
// - PulsanteHome: lo stesso aiuto dal profilo, sempre disponibile.
// - IstruzioniHome: i passi, diversi per iPhone, Android e "dentro un'altra app".
// Logica e riconoscimento del telefono in src/installazione.js.

function useHome() {
  const [, aggiorna] = useState(0);
  useEffect(() => ascoltaInstallazione(() => aggiorna(n => n + 1)), []);
  return {
    proponibile: homeProponibile(),
    stato: statoHome(),
    subito: puoInstallareSubito() && !dentroUnAltraApp(),
  };
}

const ARANCIO = '#ED4D1D';

// Icone disegnate come quelle che si vedono sul telefono, per riconoscerle.
const Icona = {
  condividi: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 3v12"/><path d="M8 7l4-4 4 4"/><path d="M8 10H6a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-2"/>
    </svg>
  ),
  aggiungi: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
      <rect x="4" y="4" width="16" height="16" rx="4"/><path d="M12 8v8M8 12h8"/>
    </svg>
  ),
  puntiniOrizzontali: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/>
    </svg>
  ),
  puntiniVerticali: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <circle cx="12" cy="5" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="12" cy="19" r="2"/>
    </svg>
  ),
};

const iconaInLinea = (icona) => (
  <span style={{ display: 'inline-flex', verticalAlign: 'middle', alignItems: 'center', justifyContent: 'center',
    width: 34, height: 34, margin: '0 2px', borderRadius: 8, background: 'rgba(255,255,255,0.08)',
    border: '1px solid rgba(255,255,255,0.15)', color: '#fff' }}>
    {icona}
  </span>
);

function Passo({ numero, children }) {
  return (
    <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start', marginBottom: 18 }}>
      <span style={{ flexShrink: 0, width: 32, height: 32, borderRadius: '50%', background: ARANCIO, color: '#fff',
        display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 17, fontWeight: 800 }}>
        {numero}
      </span>
      <div style={{ fontSize: 18, lineHeight: 1.55, color: 'var(--text)', paddingTop: 2 }}>{children}</div>
    </div>
  );
}

const bottonePieno = {
  width: '100%', minHeight: 52, padding: '12px 16px', borderRadius: 12, border: 'none', cursor: 'pointer',
  background: ARANCIO, color: '#fff', fontSize: 18, fontWeight: 800, fontFamily: 'inherit',
};
const bottoneVuoto = {
  width: '100%', minHeight: 48, padding: '10px 16px', borderRadius: 12, cursor: 'pointer',
  background: 'none', border: 'none', color: 'var(--muted)', fontSize: 17, fontWeight: 600, fontFamily: 'inherit',
};

export function IstruzioniHome({ onClose }) {
  const [copiato, setCopiato] = useState(false);
  const os = piattaforma();
  const altraApp = dentroUnAltraApp();
  const fatto = () => { segnaHome('fatto'); onClose(); };

  const copiaLink = async () => {
    try { await navigator.clipboard.writeText(window.location.href); setCopiato(true); }
    catch (e) { console.error(e); }
  };

  let titolo = 'Metti Jammo sulla Home';
  let contenuto;

  if (altraApp) {
    // Va bene qualsiasi browser: sull'iPhone anche Chrome, Edge e Firefox
    // sanno aggiungere alla Home (da iOS 16.4). Conta solo uscire dall'app.
    const esempi = os === 'ios' ? 'Safari o Chrome' : 'Chrome';
    titolo = 'Prima apri Jammo nel browser';
    contenuto = (
      <>
        <div style={{ fontSize: 18, lineHeight: 1.55, color: 'var(--text)', marginBottom: 18 }}>
          Stai guardando Jammo dentro un'altra app, e da qui non si arriva alla Home.
        </div>
        <Passo numero={1}>
          Tocca i tre puntini {iconaInLinea(os === 'ios' ? Icona.puntiniOrizzontali : Icona.puntiniVerticali)} in alto
          e scegli <b>Apri nel browser</b>. In qualche app si chiama <b>Apri in {esempi}</b>: va bene lo stesso.
        </Passo>
        <Passo numero={2}>
          Nella pagina che si apre, tocca di nuovo <b>Metti Jammo sulla Home</b>.
        </Passo>
        <div style={{ fontSize: 16, lineHeight: 1.5, color: 'var(--muted)', marginBottom: 12 }}>
          Non trovi i tre puntini? Copia il link e incollalo nel browser che usi di solito ({esempi}...).
        </div>
        <button onClick={copiaLink} style={{ ...bottonePieno, background: 'rgba(237,77,29,0.1)', color: ARANCIO, border: '2px solid ' + ARANCIO }}>
          {copiato ? 'Link copiato' : 'Copia il link'}
        </button>
        <button onClick={onClose} style={{ ...bottoneVuoto, marginTop: 6 }}>Chiudi</button>
      </>
    );
  } else if (os === 'ios') {
    const quale = browserIphone();
    contenuto = (
      <>
        <Passo numero={1}>
          Tocca il pulsante <b>Condividi</b> {iconaInLinea(Icona.condividi)}
          {quale === 'safari' && <>. Se non lo vedi, tocca prima i tre puntini {iconaInLinea(Icona.puntiniOrizzontali)} accanto all'indirizzo.</>}
          {quale === 'chrome' && <>, in alto a destra accanto all'indirizzo.</>}
          {quale === 'altro' && <>, nel menu del browser.</>}
        </Passo>
        <Passo numero={2}>
          Scorri e scegli <b>Aggiungi alla schermata Home</b> {iconaInLinea(Icona.aggiungi)}
        </Passo>
        <Passo numero={3}>
          Tocca <b>Aggiungi</b>, in alto a destra. Sulla Home compare la J di Jammo.
        </Passo>
        {/* Sull'iPhone l'app sulla Home non condivide l'accesso con Safari:
            senza questo avviso chi si e' appena registrato pensa di aver perso
            l'account. */}
        <div style={{ fontSize: 17, lineHeight: 1.55, color: 'var(--text)', background: 'rgba(237,77,29,0.08)',
          border: '1px solid rgba(237,77,29,0.3)', borderRadius: 12, padding: '12px 14px', marginBottom: 18 }}>
          La prima volta che apri Jammo dall'icona ti chiede di nuovo <b>email e codice</b>. È normale:
          succede una volta sola.
        </div>
        <button onClick={fatto} style={bottonePieno}>Fatto</button>
        <button onClick={onClose} style={{ ...bottoneVuoto, marginTop: 6 }}>Più tardi</button>
      </>
    );
  } else {
    contenuto = (
      <>
        <Passo numero={1}>
          Tocca i tre puntini {iconaInLinea(Icona.puntiniVerticali)} in alto a destra.
        </Passo>
        <Passo numero={2}>
          Scegli <b>Aggiungi a schermata Home</b> oppure <b>Installa app</b>.
        </Passo>
        <Passo numero={3}>
          Conferma con <b>Installa</b> o <b>Aggiungi</b>. Sulla Home compare la J di Jammo.
        </Passo>
        <button onClick={fatto} style={bottonePieno}>Fatto</button>
        <button onClick={onClose} style={{ ...bottoneVuoto, marginTop: 6 }}>Più tardi</button>
      </>
    );
  }

  return (
    <Modal onClose={onClose} maxWidth={420} centered>
      <div className="modal-title" style={{ marginBottom: 18 }}>{titolo}</div>
      {contenuto}
    </Modal>
  );
}

// Tocco sul pulsante: su Android con Chrome la finestra di sistema, altrimenti
// i passi. Se alla finestra di sistema dice no, Chrome non la ripropone
// subito: il pulsante torna a "Come si fa".
function usaAzione(subito, apriIstruzioni) {
  return () => { if (subito) installaOra(); else apriIstruzioni(); };
}

export function SchedaHome() {
  const { proponibile, stato, subito } = useHome();
  const [istruzioni, setIstruzioni] = useState(false);
  if (!proponibile || stato) return null;
  const azione = usaAzione(subito, () => setIstruzioni(true));

  return (
    <>
      <div style={{ marginBottom: 12, background: 'var(--surface)', border: '1px solid rgba(237,77,29,0.45)',
        borderRadius: 16, padding: '16px 18px' }}>
        <div style={{ display: 'flex', gap: 14, alignItems: 'center', marginBottom: 14 }}>
          <img src="/brand/icona-app-192.png" alt="" width="52" height="52"
            style={{ borderRadius: 12, flexShrink: 0, border: '1px solid rgba(255,255,255,0.12)' }}/>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 19, fontWeight: 800, color: 'var(--text)' }}>Metti Jammo sulla Home</div>
            <div style={{ fontSize: 16, color: 'var(--muted)', lineHeight: 1.45, marginTop: 3 }}>
              La apri con un tocco, come un'app, senza cercare il link.
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={() => segnaHome('non-ora')}
            style={{ flex: 1, minHeight: 48, borderRadius: 12, cursor: 'pointer', fontFamily: 'inherit',
              background: 'none', border: '1px solid rgba(255,255,255,0.18)', color: 'var(--muted)', fontSize: 17, fontWeight: 600 }}>
            Non ora
          </button>
          <button onClick={azione}
            style={{ flex: 2, minHeight: 48, borderRadius: 12, cursor: 'pointer', fontFamily: 'inherit',
              background: ARANCIO, border: 'none', color: '#fff', fontSize: 18, fontWeight: 800 }}>
            {subito ? 'Installa' : 'Come si fa'}
          </button>
        </div>
      </div>
      {istruzioni && <IstruzioniHome onClose={() => setIstruzioni(false)} />}
    </>
  );
}

export function PulsanteHome({ style }) {
  const { proponibile, subito } = useHome();
  const [istruzioni, setIstruzioni] = useState(false);
  if (!proponibile) return null;
  const azione = usaAzione(subito, () => setIstruzioni(true));
  return (
    <>
      <button className="btn btn-secondary" onClick={azione}
        style={{ width: '100%', justifyContent: 'center', ...style }}>
        Metti Jammo sulla Home
      </button>
      {istruzioni && <IstruzioniHome onClose={() => setIstruzioni(false)} />}
    </>
  );
}
